const DATA = [
  {
    id: 1,
    name: 'Model Reconciliation',
    paper: 'https://www.ijcai.org/Proceedings/2017/23',
    code: 'https://github.com/TathagataChakraborti/mmp',
    tldr: 'The original model reconciliation paper from IJCAI 2017.',
  },
  {
    id: 2,
    name: 'Web Planner',
    paper:
      'https://www.springerprofessional.de/en/web-planner-a-tool-to-develop-visualize-and-test-classical-plann/17832462',
    link: 'https://web-planner.herokuapp.com/',
    tldr: 'A visualization tool for the search process of a planner.',
  },
  {
    id: 3,
    name: 'iPass',
    paper:
      'https://www.tandfonline.com/doi/abs/10.1080/07370024.2020.1726751?journalCode=hhci20',
    code: 'https://github.com/yochan-lab/iPass-MasterPlan',
    tldr:
      'A proactive decision support system that helps ASU university graduate students plan an iPOS for their study.',
  },
  {
    id: 4,
    name: 'HTN Plan Viewer',
    link: 'https://maumagnaguagno.github.io/HTN_Plan_Viewer/',
    code: 'https://github.com/maumagnaguagno/HTN_Plan_Viewer',
    tldr: 'Graph visualization of HTN plans using IPC output format.',
  },
  {
    id: 4,
    name: 'String Diagrams For PDDL',
    paper: 'https://openreview.net/forum?id=YlA8hA4Z-5Z',
    code: 'https://github.com/aaguinal/String-Diagrams-For-PDDL',
    tldr:
      'A Graphical, Model-Based Representation for PDDL using Category Theory.',
  },
  {
    id: 5,
    name: 'BayesLTL',
    paper: 'https://www.ijcai.org/proceedings/2019/776',
    code: 'https://github.com/IBM/BayesLTL',
    tldr:
      'Bayesian inference of LTL specifications to explain differences across two sets of traces.',
  },
  {
    id: 6,
    name: 'JEDAI',
    paper: 'https://www.ifaamas.org/Proceedings/aamas2022/pdfs/p1917.pdf',
    code: 'https://github.com/AAIR-lab/AAIR-JEDAI',
    tldr:
      'An interactive tool for skill-aligned explainable robot planning.',
  },
    {
    id: 7,
    name: 'RADAR-X',
    paper: 'https://ojs.aaai.org/index.php/ICAPS/article/view/19837/19596',
    code: 'https://github.com/karthikv792/RADAR-X',
    tldr:
      'A naturalistic decision-support system that supports contrastive explanatory dialogue.',
  },
  {
    id: 8,
    name: 'XPP Iterative Planning',
    paper: 'https://ojs.aaai.org/index.php/ICAPS/article/view/19858',
    code: 'https://github.com/XPP-explainable-planning',
    tldr:
      'An online iterative planning tool that supports explanations based on softgoal conflicts',
  }
];

export { DATA };
